import React from "react";
import { Link } from "react-router-dom";
import Banner from "./../../component/Banner";
import Bannerimg from "./../../images/about/about2.webp";
import { Helmet } from "react-helmet";
const Carrers = () => {
  const banner = {
    title: "Career",
    image: Bannerimg,
  };
  return (
    <>
      <Helmet>
        <title>
          Career — Cylon Technologies – Big Data | Data Analytics | Digital
          Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content heading_space pb-5 small_ul light-li">
        <div className="container">
          <div className="col-md-8 mx-auto">
            <h2 className="heading_c text-center">Career</h2>
            <h3 className="heading2">Senior Software Developer</h3>
            <h5 className="mb-4">
              <b>Job Description:</b>
            </h5>
            <p>
              We are seeking an experienced and motivated Senior Software
              Developer proficient in Java to join our dynamic team. The ideal
              candidate will have a strong background in software development,
              with expertise in Java programming language, and a proven track
              record of delivering high-quality, scalable solutions.
            </p>
            <h5 className="mb-4">
              <b>Responsibilities:</b>
            </h5>
            <ul className="pb-4">
              <li>
                Design, develop, and maintain Java-based applications and
                software solutions
              </li>
              <li>
                Collaborate with cross-functional teams to define, design, and
                ship new features
              </li>
              <li>Write well-designed, efficient, and testable code</li>
              <li>
                Perform code reviews, troubleshoot, and debug software issues
              </li>
              <li>Optimize application performance and scalability</li>
              <li>
                Stay updated on emerging technologies and best practices in
                software development
              </li>
              <li>
                Mentor junior team members and contribute to their professional
                growth
              </li>
            </ul>

            <h5 className="mb-4">
              <b>Requirements:</b>
            </h5>
            <ul className="pb-4">
              <li>
                Bachelor's degree in Computer Science, Engineering, or related
                field
              </li>
              <li>
                Strong proficiency in Java programming language and related
                technologies (e.g., Spring Framework, Hibernate)
              </li>
              <li>
                Solid understanding of object-oriented programming principles
                and design patterns
              </li>
              <li>
                Experience with database technologies (e.g., SQL, MySQL,
                PostgreSQL)
              </li>
              <li>Familiarity with web services (e.g., RESTful APIs)</li>
              <li>Excellent problem-solving and analytical skills</li>
              <li>Strong communication and collaboration abilities</li>
              <li>Ability to thrive in a fast-paced, dynamic environment</li>
            </ul>

            <h5 className="mb-4">
              <b>Nice to Have:</b>
            </h5>
            <ul className="pb-4">
              <li>
                Experience with cloud platforms (e.g., AWS, Azure, Google Cloud)
              </li>
              <li>
                Knowledge of front-end technologies (e.g., JavaScript, HTML,
                CSS)
              </li>
              <li>
                Familiarity with Agile development methodologies (e.g., Scrum,
                Kanban)
              </li>
              <li>
                Contributions to open-source projects or active participation in
                tech communities
              </li>
            </ul>
            <h5 className="mb-4">
              <b>Benefits:</b>
            </h5>
            <ul className="pb-4">
              <li>Competitive salary</li>
              <li>Comprehensive health benefits package</li>
              <li>Flexible work hours</li>
              <li>Remote work opportunities</li>
              <li>Professional development and training programs</li>
              <li>Company-sponsored events and team outings</li>
            </ul>
            <h5 className="mb-4">
              <b>How to Apply:</b>
            </h5>
            <p>
              If you're passionate about software development and ready to take
              on new challenges, we'd love to hear from you! Please submit your
              resume and a cover letter detailing your relevant experience and
              why you're interested in joining Cylon Technologies.
            </p>
            <p>
              mailto:{" "}
              <Link to="mailto:info@cylontechnology.com">
                info@cylontechnology.com
              </Link>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Carrers;
